<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Users' }">
              <h4 class="ms-2">
                {{ label.pages.users }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="items"
            :columns="fields"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <b-row>
                <b-col cols="5">
                  <date-picker
                    class="p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="form.fromDateLocal"
                    :clearable="true"
                    :editable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt">
                        {{ label.pages.fromDate }}</span
                      >
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="5">
                  <date-picker
                    class="p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="form.toDateLocal"
                    :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt">
                        {{ label.pages.toDate }}</span
                      >
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="2">
                  <b-button
                    variant="ps-second"
                    class="py-1"
                    size="sm"
                    v-b-tooltip.hover
                    @click="reloadData"
                    :title="label.pages.search"
                  >
                    <b-icon icon="search" />
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-success"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.addDiscount"
                      @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{ data }">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{ data }">
              <div>
                <img
                  :src="data.data.imageAddress"
                  class="ps_table_inside_img"
                />
              </div>
            </template>
            <template #actions="{ data }">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    @click="edit(data)"
                    :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-edit-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="delConfirm(data)"
                    :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="1.1"
                      variant="ps-delete-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxSorting mode="multiple" />
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
            <DxStateStoring
              :enabled="true"
              type="localStorage"
              storage-key="adminDiscountList"
            />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
      dir="rtl"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
      size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.newDiscount }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="addModal = false"
          id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="6">
            <date-picker
              class="p-datePicker"
              color="#7dc13e"
              input-class="p-datePicker-input"
              :auto-submit="true"
              v-model="form.fromDateLocal"
              :clearable="true"
            >
              <div slot="label">
                <span style="font-size: 9pt">{{ label.pages.fromDate }} </span>
              </div>
            </date-picker>
          </b-col>

          <b-col cols="6">
            <date-picker
              class="p-datePicker"
              color="#7dc13e"
              input-class="p-datePicker-input"
              :auto-submit="true"
              v-model="form.toDateLocal"
              :clearable="true"
            >
              <div slot="label">
                <span style="font-size: 9pt"> {{ label.pages.toDate }}</span>
              </div>
            </date-picker>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="mb-2 mt-3">
            <label for="code" class="ps_label pe-2">
              {{ label.form.discountCode }}
              <span class="ps_label_star">*</span>
            </label>
            <b-input-group>
              <b-form-input
                size="sm"
                v-model="form.code"
                type="text"
                class="text-center"
                style="border-radius: 0 5px 5px 0"
              />
              <b-input-group-append>
                <b-button
                  variant="p-secondary-outline"
                  v-b-tooltip.hover
                  size="sm"
                  :title="label.buttons.changeCode"
                  style="border-radius: 5px 0 0 5px"
                  @click="changeCode"
                >
                  <b-icon icon="arrow-clockwise" scale="1.2" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="mb-2 mt-3">
            <label for="introducer" class="ps_label pe-2">
              {{ label.form.introducer }}
            </label>
            <v-select
              input-id="introducer"
              :options="introducer"
              v-model="form.introducerId"
              :reduce="(group) => group.id"
              :clearable="true"
              size="sm"
              class="ps_select"
            >
            </v-select>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="discountAmountType" class="ps_label pe-2">
              {{ label.form.discountType }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="discountAmountType"
              :options="discountType"
              v-model="form.discountAmountTypeId"
              :reduce="(group) => group.id"
              :clearable="true"
              size="sm"
              class="ps_select"
            >
            </v-select>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label
              for="amount"
              class="ps_label pe-2"
              v-if="form.discountAmountTypeId == 1"
            >
              {{ label.form.amount }} ({{ label.form.percent }})
              <span class="ps_label_star">*</span>
            </label>
            <label for="amount" class="ps_label pe-2" v-else>
              {{ label.form.amount }} ({{ label.form.rial }})
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="amount"
              size="sm"
              v-model="form.amount"
              type="number"
              class="text-center"
            />
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="count" class="ps_label pe-2">
              {{ label.form.useCount }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="count"
              size="sm"
              v-model="form.count"
              type="number"
              class="text-center"
            />
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="description" class="ps_label pe-2">
              {{ label.form.description }}
            </label>
            <b-form-textarea
              rows="2"
              id="description"
              size="sm"
              v-model="form.description"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="addModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addItem"
            >
              {{ label.buttons.submitInfo }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
      dir="rtl"
      v-model="editModal"
      header-bg-variant="ps-warning"
      centered
      size="lg"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.editDiscount }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="editModal = false"
          id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="6">
            <date-picker
              class="p-datePicker"
              color="#fca31d"
              input-class="p-datePicker-input"
              :auto-submit="true"
              v-model="form.fromDateLocal"
              :clearable="true"
            >
              <div slot="label">
                <span style="font-size: 9pt">{{ label.pages.fromDate }} </span>
              </div>
            </date-picker>
          </b-col>

          <b-col cols="6">
            <date-picker
              class="p-datePicker"
              color="#fca31d"
              input-class="p-datePicker-input"
              :auto-submit="true"
              v-model="form.toDateLocal"
              :clearable="true"
            >
              <div slot="label">
                <span style="font-size: 9pt"> {{ label.pages.toDate }}</span>
              </div>
            </date-picker>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="mb-2 mt-3">
            <label for="code" class="ps_label pe-2">
              {{ label.form.discountCode }}
              <span class="ps_label_star">*</span>
            </label>
            <b-input-group>
              <b-form-input
                size="sm"
                v-model="form.code"
                type="text"
                class="text-center"
                style="border-radius: 0 5px 5px 0"
              />
              <b-input-group-append>
                <b-button
                  variant="p-secondary-outline"
                  v-b-tooltip.hover
                  size="sm"
                  :title="label.buttons.changeCode"
                  style="border-radius: 5px 0 0 5px"
                  @click="changeCode"
                >
                  <b-icon icon="arrow-clockwise" scale="1.2" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="mb-2 mt-3">
            <label for="introducer" class="ps_label pe-2">
              {{ label.form.introducer }}
            </label>
            <v-select
              input-id="introducer"
              :options="introducer"
              v-model="form.introducerId"
              :reduce="(group) => group.id"
              :clearable="true"
              size="sm"
              class="ps_select"
            >
            </v-select>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="discountAmountType" class="ps_label pe-2">
              {{ label.form.discountType }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="discountAmountType"
              :options="discountType"
              v-model="form.discountAmountTypeId"
              :reduce="(group) => group.id"
              :clearable="true"
              size="sm"
              class="ps_select"
            >
            </v-select>
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label
              for="amount"
              class="ps_label pe-2"
              v-if="form.discountAmountTypeId == 1"
            >
              {{ label.form.amount }} ({{ label.form.percent }})
              <span class="ps_label_star">*</span>
            </label>
            <label for="amount" class="ps_label pe-2" v-else>
              {{ label.form.amount }} ({{ label.form.rial }})
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="amount"
              size="sm"
              v-model="form.amount"
              type="number"
              class="text-center"
            />
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="count" class="ps_label pe-2">
              {{ label.form.useCount }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="count"
              size="sm"
              v-model="form.count"
              type="number"
              class="text-center"
            />
          </b-col>

          <b-col lg="6" md="12" sm="12" class="my-2">
            <label for="description" class="ps_label pe-2">
              {{ label.form.description }}
            </label>
            <b-form-textarea
              rows="2"
              id="description"
              size="sm"
              v-model="form.description"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="editModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editItem"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              variant="ps-warning"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal dir="rtl" v-model="delModal" hide-header centered>
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm }}
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="delModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteItem"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";
import moment from "moment-jalaali";
const startMonth = moment().startOf("jM").format("jYYYY/jMM/jDD");
const endMonth = moment().endOf("jM").format("jYYYY/jMM/jDD");

export default {
  name: "DiscountList",
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          cellTemplate: "radif",
          caption: "ردیف",
          allowSorting: false,
          allowFiltering: false,
          cssClass: "text-center align-middle fs10",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          cssClass: "text-center align-middle",
        },
        {
          dataField: "code",
          caption: "کد تخفیف",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "discountAmountTypeTitle",
          caption: "نوع تخفیف",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "amount",
          caption: "مقدار تخفیف",
          dataType: "number",
          format: "###,###",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "count",
          caption: "تعداد استفاده",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "fromDateLocal",
          caption: "از تاریخ",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "toDateLocal",
          caption: "تا تاریخ",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "description",
          caption: "توضیحات",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],
      addModal: false,
      form: {
        code: null,
        discountAmountTypeId: null,
        amount: null,
        count: null,
        introducerId: null,
        description: null,
        fromDateLocal: startMonth,
        toDateLocal: endMonth,
      },

      editModal: false,
      editId: null,

      delModal: false,
      delId: null,
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      items: "operationX/discounts",
      introducer: "operationX/introducerOptions",
      discountType: "operationX/discountTypeOptions",
      loadingBtn: "loadingBtn",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadData();
        this.reloadFields();
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
      }
    },
  },
  methods: {
    changeCode() {
      let result = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const digits = "0123456789";
      result = characters.charAt(Math.random() * 26);
      result += digits.charAt(Math.random() * 10);
      result += characters.charAt(Math.random() * 26);
      result += digits.charAt(Math.random() * 10);
      result += digits.charAt(Math.random() * 10);
      this.form.code = result;
    },
    add() {
      this.reloadFields();
      this.changeCode();
      this.addModal = true;
    },
    addItem() {
      this.$store.commit("setLoadingBtn", true);
      if (
        this.form.discountAmountTypeId &&
        this.form.fromDateLocal &&
        this.form.toDateLocal &&
        this.form.amount &&
        this.form.count &&
        this.form.code
      ) {
        this.$store.dispatch("operationX/addDiscount", this.form);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    edit(item) {
      this.editId = item.data.id;
      this.form = {
        discountAmountTypeId: item.data.discountAmountTypeId,
        introducerId: item.data.introducerId,
        fromDateLocal: item.data.fromDateLocal,
        toDateLocal: item.data.toDateLocal,
        amount: item.data.amount,
        count: item.data.count,
        code: item.data.code,
        description: item.data.description,
      };
      this.editModal = true;
    },
    editItem() {
      this.$store.commit("setLoadingBtn", true);
      if (
        this.form.discountAmountTypeId &&
        this.form.fromDateLocal &&
        this.form.toDateLocal &&
        this.form.amount &&
        this.form.count &&
        this.form.code
      ) {
        const values = {
          id: this.editId,
          value: this.form,
        };
        this.$store.dispatch("operationX/editDiscount", values);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.dispatch("operationX/deleteDiscount", this.delId);
    },
    reloadFields() {
      this.form = {
        code: null,
        discountAmountTypeId: null,
        amount: null,
        count: null,
        introducerId: null,
        description: null,
        fromDateLocal: startMonth,
        toDateLocal: endMonth,
      };
    },
    reloadData() {
      let payload = "fromDateLocal=" + this.form.fromDateLocal;
      payload += "&toDateLocal=" + this.form.toDateLocal;
      this.$store.dispatch("operationX/getDiscounts", payload);
    },
  },
  mounted() {
    this.reloadData();
    this.$store.dispatch("operationX/getIntroducers");
    this.$store.dispatch("operationX/getDiscountType");
  },
};
</script>
